import React from "react";
import classNames from "classnames";
import { XMarkIcon } from "@heroicons/react/24/outline";

import { CollapsibleBottomBarProps } from "./types";

export const CollapsibleBottomBar = (props: CollapsibleBottomBarProps) => {
  React.useLayoutEffect(() => {
    const addFixedToBody = () => {
      document.body.style.position = "fixed";
      document.body.style.top = "0";
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.bottom = "0";
    };

    const removeFixedFromBody = () => {
      document.body.style.position = "";
    };

    if (props.show) {
      addFixedToBody();
    } else {
      removeFixedFromBody();
    }

    return () => {
      removeFixedFromBody();
    };
  }, [props.show]);

  React.useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        props.setShow(false);
      }
    };

    document.addEventListener("keydown", handleEsc);

    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, [props]);

  return (
    <>
      {props?.show ? (
        <div
          onClick={() => props.setShow(false)}
          className={classNames(
            props?.style?.pannel,
            "top-0 left-0 w-screen h-screen bg-black z-40 !bg-opacity-50 fixed"
          )}
        />
      ) : null}
      <div
        className={classNames(
          "left-0 bottom-0 w-full bg-white border-t rounded-t-xl p-4 fixed z-40 ease-in-out duration-300",
          props.show ? "translate-y-0" : "!translate-y-full",
          props?.style?.container ?? ""
        )}
        style={{
          transform: props?.show ? "translateY(0)" : "translateY(100%)",
        }}
      >
        {!!props?.title && (
          <div
            className={classNames(
              "flex justify-between items-center text-[#343F59] text-xl",
              props?.style?.title
            )}
          >
            <p>{props.title}</p>
            <XMarkIcon
              className={classNames(
                "w-5 h-5 cursor-pointer",
                props?.style?.xMark
              )}
              onClick={() => props.setShow(false)}
            />
          </div>
        )}
        {props.children}
      </div>
    </>
  );
};
